import React, { useRef, useMemo, Component } from 'react';
import { useState, useEffect } from 'react';
import {
    basePort, getUsernameJwt, isExpiredJwt, renderRedirect, multipartHeaders,
    getJwtFromCookies, setMutipartTokenHeader
} from "../../module_auth/AuthService"
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { ToastMessage } from "../../component/common/Toast"
import { ImageFileUploadButton } from "../common/FileUploadButton"
import '../../App.css'
import ImageResize from 'quill-resize-image';
Quill.register('modules/imageResize', ImageResize);

export function BlogRegAdmin() {
    //블로그상세
    const [mbrId, setMbrId] = useState("");
    const [blogTitle, setBlogTitle] = useState("");
    const [summary, setSummary] = useState("");
    const [value, setValue] = useState('');

    const [fileData, setFileData] = useState('');
    const [fileExist, setFileExist] = useState(false);

    const [slug, setSlug] = useState("");
    const [fileSource, setFileSource] = useState("");
    //End 블로그상세

    const [jwtToken, setJwtToken] = useState("");
    const [redirect, setRedirect] = useState(false);
    const [accessToken, setAccessToken] = useState("");

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    const quillRef = useRef(null);

    useEffect(() => {
        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setMbrId(getUsernameJwt(getJwtFromCookies()))
        }
    }, []);

    function clickSubmit(event) {
        event.preventDefault();

        const formData = new FormData()
        formData.append('File', fileData)

        let jsonStr = JSON.stringify({
            mbrId: mbrId,
            blogTitle: blogTitle,
            summary: summary,
            blogContent: value,
            fileSource: fileSource,
            slug: slug
        })
        formData.append('JsonStr', jsonStr)

        let headers = multipartHeaders
        setMutipartTokenHeader(getJwtFromCookies())

        fetch(basePort + '/post/blog',
            {
                method: 'post', headers,
                body: formData
            })
            .then(response => response.json())
            .then(response => {
                if (response.validRequest) {
                    fadeOutToast(response.validationMessage)
                    setTimeout(function () {
                        moveTo()
                    }.bind(this), 3000)
                } else {
                    fadeOutToast(response.validationMessage)
                }
            }).catch(function (error) {
                console.log(error);
            });
    }

    function fadeOutToast(msg) {
        setToastMessage(true, msg)
        setTimeout(function () {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message) {
        setShowToast(show)
        setMsgToast(message)
    }

    let navigate = useNavigate();
    function moveTo() {
        let url = "/blog_list_admin"
        navigate(url);
    }

    function handleBlogTitle(event) {
        setBlogTitle(event.target.value);
    }

    function handleImage() {
        //nothing
    }

    function removeFile() {
        document.getElementById("chooseFile").value = ""
        setFileData("")
        setFileExist(false)
    }

    function handleFileSource(event) {
        setFileSource(event.target.value);
    }

    function handleSlug(event) {
        setSlug(event.target.value);
    }

    // 1. 이미지 버튼을 클릭했을 때만 실행될 커스텀 핸들러
    const imageHandler = () => {
        const url = prompt('이미지 URL 링크를 입력하세요:');

        if (url) {
            const quill = quillRef.current.getEditor();
            const range = quill.getSelection();

            // 커서 위치를 찾지 못했다면 맨 마지막에 삽입
            const index = range ? range.index : quill.getLength();
            quill.insertEmbed(index, 'image', url);

            // 🎯 [추가] 방금 삽입한 이미지 태그를 찾아서 일관된 반응형 스타일을 부여합니다.
            setTimeout(() => {
                // 현재 에디터 루트 안에서 방금 넣은 URL을 가진 img 태그들을 모두 찾습니다.
                const images = quill.root.querySelectorAll(`img[src="${url}"]`);
            }, 10);
        }
    };

    // 2. modules 설정을 useMemo로 감싸고, handlers에 함수 이름만 전달합니다.
    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                [{ size: [] }],
                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link', 'image'],
                ['clean'],
                ['code-block']
            ],
            handlers: {
                image: imageHandler, // 괄호()를 빼고 함수 자체를 참조해야 클릭 시 실행됩니다.
            },
        },
        // 👇 이 부분을 추가하면 에디터 안에서 이미지 클릭 시 조절창이 뜹니다.
        imageResize: {
            modules: ['Resize', 'DisplaySize', 'Toolbar']
        }
    }), []); // 빈 배열을 넣어 처음 렌더링될 때 한 번만 생성되도록 합니다.

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{ paddingTop: '100px', marginTop: '10px', marginBottom: '10px' }}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>블로그</span></li>
                            <li class="breadcrumb-item"><span>블로그등록</span></li>
                        </ol>
                        <form><label class="form-label" style={{ textAlign: 'left', fontWeight: 'bold' }}>제목</label>
                            <input class="form-control" type="text" onChange={handleBlogTitle} />
                        </form>
                        <form style={{ marginTop: '10px', marginRight: '0', marginLeft: '0' }}>
                            <label class="form-label" style={{ textAlign: 'left', fontWeight: 'bold' }}>요약</label>
                            <div class="container" style={{ height: '350px', marginBottom: '10px' }}>
                                <ReactQuill theme="snow" value={summary} onChange={setSummary}
                                    style={{ height: '300px', marginBottom: '10px' }}
                                    modules={{
                                        toolbar: {
                                            container: [
                                                [{ header: '1' }, { header: '2' }, { header: [3, 4, 5, 6] }, { font: [] }],
                                                [{ size: [] }],
                                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                [{ list: 'ordered' }, { list: 'bullet' }],
                                                ['image'],
                                                ['clean'],
                                                ['code-block']
                                            ],
                                            handlers: {
                                                image: handleImage(),
                                            },
                                        },

                                    }}
                                />
                            </div>
                        </form>
                        <form style={{ marginTop: '10px', marginRight: '0', marginLeft: '0' }}>
                            <label class="form-label" style={{ textAlign: 'left', fontWeight: 'bold' }}>내용</label>
                            <div class="container blog-detail-content" style={{ height: '350px', marginBottom: '10px' }}>
                                <ReactQuill theme="snow" value={value} onChange={setValue}
                                    ref={quillRef}
                                    style={{ height: '300px', marginBottom: '10px' }}
                                    modules={modules}
                                />
                            </div>
                        </form>
                        <form><label class="form-label" style={{ marginTop: '10px', textAlign: 'left', fontWeight: 'bold' }}>SLUG</label>
                            <input class="form-control" type="text" onChange={handleSlug} />
                        </form>
                        <form><label class="form-label" style={{ marginTop: '10px', textAlign: 'left', fontWeight: 'bold' }}>파일출처</label>
                            <input class="form-control" type="text" onChange={handleFileSource} />
                        </form>
                        <ImageFileUploadButton
                            setFileData={setFileData}
                            setFileExist={setFileExist}
                            removeFile={removeFile}
                            fileExist={fileExist}
                        />
                        <form style={{ textAlign: 'center', marginBottom: '10px', marginTop: '30px' }}>
                            <button class="btn btn-secondary" type="button" onClick={moveTo} style={{ marginRight: '5px' }}>취소하기</button>
                            <button class="btn btn-primary" type="button" onClick={clickSubmit}>저장하기</button>
                        </form>
                        <ToastMessage show={showToast} msg={msgToast} />
                    </div>
                </section>
            </main>
        </div>
    );
}